import axios from "axios";

const resolveBackendUrl = () => {
  const prod = process.env.REACT_APP_BACKEND_URL;
  const local = process.env.REACT_APP_BACKEND_URL_LOCAL;
  const forceLocal = process.env.REACT_APP_USE_LOCAL_BACKEND === "true";
  const isDev = process.env.NODE_ENV === "development";
  return (forceLocal || isDev) && local ? local : prod;
};

const BACKEND_URL = resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Global request-pending counter + listeners (drives the top progress bar)
let _pending = 0;
const _listeners = new Set();
const _emit = () => _listeners.forEach((fn) => fn(_pending));
export const subscribeLoading = (fn) => {
  _listeners.add(fn);
  fn(_pending);
  return () => _listeners.delete(fn);
};

// Attach fallback Bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pos_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Attach selected outlet_id to GET requests automatically (unless explicitly set)
  const method = (config.method || "get").toLowerCase();
  if (method === "get") {
    const oid = localStorage.getItem("pos_outlet") || "";
    if (oid && (!config.params || !("outlet_id" in config.params))) {
      config.params = { ...(config.params || {}), outlet_id: oid };
    }
  }
  if (!config._silent) {
    _pending += 1;
    _emit();
  }
  return config;
});

const _decrement = (cfg) => {
  if (cfg && !cfg._silent) {
    _pending = Math.max(0, _pending - 1);
    _emit();
  }
};

api.interceptors.response.use(
  (res) => {
    _decrement(res.config);
    return res;
  },
  (err) => {
    _decrement(err?.config);
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export default api;
